module.exports = __webpack_public_path__ + "static/media/Bitter-Regular.c5338da0.woff";